import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/trigger_play.png'


const _withScopeId = n => (_pushScopeId("data-v-2be7d00d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "umi-container" }
const _hoisted_2 = {
  key: 0,
  class: "chat-content"
}
const _hoisted_3 = { class: "message_content" }
const _hoisted_4 = { class: "text_content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "scale_info"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space_line" }, null, -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "trigger_chat_content"
}
const _hoisted_11 = {
  key: 0,
  class: "play_icon_bg"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "trigger_play_icon"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.triggerType == -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, [
                _createElementVNode("span", {
                  ref: "mathjaxRef",
                  innerHTML: _ctx.text ? _ctx.text : ''
                }, null, 8, _hoisted_5),
                (_ctx.isLoding)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "loading_img",
                      src: require('../assets/image/dots.gif')
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.itemScaleIdentify && _ctx.scaleIdIdentify == _ctx.itemScaleIdentify)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("button", {
                    class: "scale_button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scaleButtonClick && _ctx.scaleButtonClick(...args)))
                  }, " 相关测评 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.fromAudio)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "from_audio_img",
                src: require('../assets/image/chat_message_from_audio.png')
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.triggerType == 2 || _ctx.triggerType == 4)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle({
          width: _ctx.imgWidth + 'rem',
          height: _ctx.imgHeight + 'rem',
          backgroundImage: 'url(' + _ctx.thumbnailImg + ')',
        }),
                class: "trigger_chat_img",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickImg && _ctx.clickImg(...args)))
              }, null, 4))
            : (_ctx.triggerType == 3 || _ctx.triggerType == 5)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "trigger_chat_video",
                  style: _normalizeStyle({
          width: _ctx.imgWidth + 'rem',
          height: _ctx.imgHeight + 'rem',
          backgroundImage: 'url(' + _ctx.thumbnailImg + ')',
        }),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickVideo && _ctx.clickVideo(...args)))
                }, [
                  (_ctx.triggerType == 3 || _ctx.triggerType == 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                    : _createCommentVNode("", true)
                ], 4))
              : _createCommentVNode("", true)
        ]))
  ]))
}